// Frozen copy of main's code for the document_generation_v4_enabled / agency_brand_design_enabled flag-off path; delete with the flag.
import { Extension } from '@tiptap/core';

export const StyleAttributeExtension = Extension.create({
  addGlobalAttributes() {
    return [
      {
        types: [
          'div',
          'section',
          'paragraph',
          'heading',
          'image',
          'listItem',
          'bulletList',
          'orderedList',
          'blockquote',
          'codeBlock',
          'table',
          'tableRow',
          'tableCell',
          'tableHeader'
        ],
        attributes: {
          style: {
            default: null,
            parseHTML: (element) => {
              const style = element.getAttribute('style');
              if (!style) return null;

              const cleanedStyle = style
                .split(';')
                .map((s) => s.trim())
                .filter((s) => s && !s.toLowerCase().startsWith('text-align'))
                .join('; ');

              return cleanedStyle || null;
            },
            renderHTML: (attributes) => {
              let styleString = attributes.style || '';

              if (styleString) {
                styleString = styleString
                  .split(';')
                  .map((s) => s.trim())
                  .filter((s) => s && !s.toLowerCase().startsWith('text-align'))
                  .join('; ');
              }

              if (attributes.backgroundColor) {
                const bgColorStyle = `background-color: ${attributes.backgroundColor}`;
                styleString = styleString ? `${styleString}; ${bgColorStyle}` : bgColorStyle;
              }

              return styleString ? { style: styleString } : {};
            }
          },
          id: {
            default: null,
            parseHTML: (element) => element.getAttribute('id'),
            renderHTML: (attributes) => ({ id: attributes.id || undefined })
          },
          class: {
            default: null,
            parseHTML: (element) => element.getAttribute('class'),
            renderHTML: (attributes) => ({ class: attributes.class || undefined })
          },
          backgroundColor: {
            default: null,
            parseHTML: (element) => {
              const style = element.getAttribute('style');
              if (style) {
                const match = style.match(/background-color:\s*([^;]+)/);
                if (match) return match[1].trim();
              }
              return null;
            },
            renderHTML: () => ({})
          }
        }
      }
    ];
  }
});
